export default __webpack_public_path__ + "d50351ec504705e38c3159c29e34ecb8.png";